import ListWrapper from 'components/ListWrapper';
import PageHeader from 'components/PageHeader';
import Typography from 'components/Typography';
import Modal from 'components/Modal';

import styles from '../Settings.module.scss';
import Button from 'components/Button';
import FormGroup from '../../../components/FormGroup';
import TextField from '../../../components/TextField';
import FormActionGroup from '../../../components/FormActionGroup';
import companyImage from 'assets/company.jpg';
import stripe from 'assets/stripe.png';
import {Controller} from 'react-hook-form';
import SelectField from 'components/SelectField';
import DeleteModal from 'components/DeleteModal';
import {PAYMENT_GATEWAY_OPTIONS} from 'constants/select-options';
import {InfoIcon} from 'pages/PaymentForm/icons';
import classNames from 'classnames';
import ListTabs from './components/ListTabs';
import integrationsStyles from './Integrations.module.scss';
import AddShopifyStoreModal from './components/AddShopifyStoreModal';
import DeleteIntegrationModal from './components/DeleteIntegrationModal';
import IntegrationList from './components/IntegrationList';
import {useIntegrations} from './useIntegrations';

function PaymentGateway() {
  const {
    tab,
    TABS,
    handleTabChange,
    handleOrdersClose,
    submithandler,
    handleDeletePaymentGateway,
    handleDeleteIntegration,
    openDeleteModal,
    handleConnectIntegration,
    data,
    isLoading,
    integrationsData,
    integrationsLoading,
    currentUser,
    control,
    watch,
    errors,
    register,
    handleSubmit,
    setModalOpen,
    setCurrentGateWay,
    setIsDeleteVisible,
    setConnectIntegrationModal,
    setIsDeleteIntegrationModalOpen,
    isDeleteVisible,
    currentIntegration,
    submitting,
    currentGateWay,
    isModalOpen,
    connectIntegrationModal,
    isDeleteIntegrationModalOpen,
    isDeleting,
    refetchIntegrations,
  } = useIntegrations();

  return (
    <div className={styles.main_container}>
      <PageHeader className={styles.top_header}>
        <Typography variant="h2">Integrations</Typography>
      </PageHeader>
      <div style={{height: 20}} />

      <ListWrapper>
        <ListTabs
          tab={tab}
          tabs={TABS}
          onChange={handleTabChange}
          activeTabValue={tab}
        />
        {tab === 'payment_gateway' && (
          <>
            <div className={integrationsStyles.buttonWrapper}>
              {data?.results && data?.results?.length < 1 && (
                <Button size="sm" onClick={() => setModalOpen(true)}>
                  Add New Gateway
                </Button>
              )}
            </div>
            {!isLoading && data?.results && data?.results.length < 1 && (
              <div className={styles.centeredColumn}>
                <Typography component="h2" variant="h2">
                  No Payment Integration Found
                </Typography>
                <p
                  className={classNames(
                    styles.centeredText,
                    styles.m20,
                    styles.fw400,
                    styles.opacity04,
                    styles.max500,
                    styles.lh13
                  )}
                >
                  You currently have no payment integrations set up. Use the
                  "Add New Gateway" button to add your preferred payment gateway
                  and start processing payments.
                </p>
              </div>
            )}

            <div className={integrationsStyles.gatewayList}>
              {data?.results.map((item) => {
                return (
                  <div
                    onClick={() => {
                      setCurrentGateWay(item);
                      setIsDeleteVisible(true);
                    }}
                    key={item.id}
                    className={integrationsStyles.gatewayCard}
                  >
                    <div>
                      <h2>
                        {item.gateway_type === 'stripe'
                          ? 'Stripe'
                          : 'Heartland'}
                      </h2>
                      <p className={styles.fs20}>
                        Company Name: {item.company_name}
                      </p>
                    </div>
                    <img
                      alt={`gateway ${item.id}`}
                      className={styles.gatewayImg}
                      src={
                        item.gateway_type === 'stripe' ? stripe : companyImage
                      }
                    />
                  </div>
                );
              })}
            </div>
          </>
        )}
        {tab === 'other_integrations' && (
          <>
            {!integrationsLoading && (
              <IntegrationList
                integrations={integrationsData}
                onConnect={handleConnectIntegration}
                onDisconnect={openDeleteModal}
              />
            )}
          </>
        )}
      </ListWrapper>

      {!!connectIntegrationModal && (
        <AddShopifyStoreModal
          isOpen={connectIntegrationModal === 'shopify'}
          handleClose={() => setConnectIntegrationModal(null)}
          refetch={refetchIntegrations}
        />
      )}
      {isDeleteIntegrationModalOpen && (
        <DeleteIntegrationModal
          isOpen={isDeleteIntegrationModalOpen}
          onRequestClose={() => setIsDeleteIntegrationModalOpen(false)}
          onDelete={handleDeleteIntegration}
          integration={currentIntegration!}
          isDeleting={isDeleting}
        />
      )}
      <Modal
        isOpen={isModalOpen}
        onClose={handleOrdersClose}
        className={styles.list_wrapper}
      >
        <Typography variant="h1" style={{marginTop: 20}}>
          Company: {currentUser?.company?.name}
        </Typography>
        <div className={styles.formWrapper}>
          <FormGroup columns={1}>
            <Controller
              name="gateway_type"
              control={control}
              defaultValue={PAYMENT_GATEWAY_OPTIONS[1]}
              rules={{required: true}}
              render={({field: {ref, ...field}}) => (
                <SelectField
                  label="Gateway type"
                  placeholder="Click To Select"
                  options={PAYMENT_GATEWAY_OPTIONS}
                  error={errors.gateway_type?.message}
                  {...field}
                />
              )}
            />
          </FormGroup>
          {watch('gateway_type')?.value === 'heartland' ? (
            <>
              <FormGroup columns={1}>
                <TextField
                  label="Secret Api Key"
                  placeholder="Enter Api Key"
                  {...register('secret_api_key', {required: 'Required'})}
                  error={errors.secret_api_key?.message}
                />
              </FormGroup>
              <FormGroup columns={1}>
                <TextField
                  label="Public Api Key"
                  placeholder="Enter Public Api Key"
                  {...register('public_api_key', {required: 'Required'})}
                  error={errors.public_api_key?.message}
                />
              </FormGroup>
              <FormGroup columns={1}>
                <TextField
                  label="Developer ID"
                  placeholder="Enter ID"
                  {...register('developer_id', {required: 'Required'})}
                  error={errors.developer_id?.message}
                />
              </FormGroup>
              <FormGroup columns={1}>
                <TextField
                  label="Version Number"
                  placeholder="Enter Number"
                  {...register('version_number', {required: 'Required'})}
                  error={errors.version_number?.message}
                />
              </FormGroup>
            </>
          ) : (
            <>
              <FormGroup columns={1}>
                <TextField
                  label="Stripe Secret Api Key"
                  placeholder="Enter Api Key"
                  {...register('stripe_secret_api_key', {required: 'Required'})}
                  error={errors.stripe_secret_api_key?.message}
                />
              </FormGroup>
              <FormGroup columns={1}>
                <TextField
                  label="Stripe Public Api Key"
                  placeholder="Enter Public Key"
                  {...register('stripe_public_key', {required: 'Required'})}
                  error={errors.stripe_public_key?.message}
                />
              </FormGroup>

              <Typography variant="p" className={styles.linkText}>
                <InfoIcon width={14} height={14} className={styles.infoIcon} />
                If you don't have a Stripe account, you can create one&nbsp;
                <a
                  className={styles.link}
                  href="https://dashboard.stripe.com/register"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here
                </a>
                .
              </Typography>
            </>
          )}

          <FormActionGroup className={styles.buttonWrap}>
            <Button
              onClick={handleSubmit(submithandler)}
              type="submit"
              loading={submitting || isLoading}
            >
              Save
            </Button>
          </FormActionGroup>
        </div>
      </Modal>
      <DeleteModal
        text="Are you sure you want to delete this gateway?"
        openModal={isDeleteVisible}
        setOpenModal={setIsDeleteVisible}
        onDelete={handleDeletePaymentGateway}
        component={
          <div className={styles.deleteInfoRow}>
            <div className={styles.mt15}>
              <Typography
                className={[styles.fs20, styles.capital].join(' ')}
                variant="p"
              >
                {currentGateWay?.gateway_type}
              </Typography>
              <Typography
                className={[styles.fs18, styles.capital, styles.m20].join(' ')}
                variant="p"
              >
                Company ID: {currentGateWay?.company_id}
              </Typography>
            </div>
            <img
              alt={`gateway ${currentGateWay?.id}`}
              className={styles.gatewayImg}
              src={
                currentGateWay?.gateway_type === 'stripe'
                  ? stripe
                  : companyImage
              }
            />
          </div>
        }
      />
    </div>
  );
}

export default PaymentGateway;
